module.exports = __webpack_public_path__ + "img/sol_1.c97d6d18.jpg";